import { Component, OnInit } from '@angular/core';
import { menuModel, subMenuModel } from 'src/app/ViewModel/ApplicationMenu.Model';
import { MenuService } from 'src/app/Service/application-menu/menu.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';

@Component({
	selector: 'app-menu-role-link',
	templateUrl: './menu-role-link.component.html',
	styleUrls: ['./menu-role-link.component.css']
})

export class MenuRoleLinkComponent implements OnInit {

	menuData: any[] = [];
	finelDate: any[] = [];
	private userMappedObject = new Map<string, boolean>();
	private userMappedObjFromDB = new Map<string, boolean>();
	private businessGroupId: number | undefined | null;
	private roleHeader:any = {};
	enableFullscreen = false;
	rolesList: any = [];
	private businessGroupList: ReadonlyArray<BusinessGroupModel> = [];
	menuHeader:any = {};

	constructor(public _notificationService: NotificationService, private commonService: CommonService, private menuService: MenuService, private mapRoleFeatureService: MapRoleFeatureService) {
		this.commonService.selectedProjectId.subscribe(data => {
			if (data != null || data != undefined) {
				this.getBusinessGroupList(data);
			}
		});
	}

	ngOnInit() {
	}

	checkGridHeight() {
		if (this.menuData.length > 0)
			return 600;
		else
			return 400;
	}

	callAPIs() {
		this.getRoleData(this.businessGroupId);
		this.getMenuData();
	}

	getBusinessGroupList(projectId: number) {
		this.mapRoleFeatureService.getBusinessGroups(projectId).subscribe((data: BusinessGroupModel[]) => {
			this.businessGroupList = data.filter(eachData => eachData.is_Active);
		});
	}

	async getRoleData(businessGroupId: number | null | undefined) {
		this.rolesList = await this.mapRoleFeatureService.getDedAgainstDe('Role', businessGroupId, null, null).toPromise();
		this.getRoleMenuMappingData();
	}

	mapMemberRole(isChecked: boolean, menuId: number, dedId: number) {
		let key = `${menuId}_${dedId}`;
		if (this.userMappedObject.has(key)) {
			this.userMappedObject.delete(key);
		} else {
			this.userMappedObject.set(key, isChecked);
		}
		this.setMenuHeader(menuId);
		this.setRoleHeader(dedId);
	}

	convertData = (menuId: number, roleId: number, isActive: boolean) => ({ menuId, roleId, isActive });

	submitMapped() {
		let roleMenusMapping = this.formatDataUiToDb();
		if(!roleMenusMapping.length)
		{
			this._notificationService.showToast("No new changes done", "Warning");
			return;
		}
		this.menuService.getMenuRoleMapping(roleMenusMapping, this.businessGroupId).subscribe(data => {
			if (data["successCode"] == 200) {
				this._notificationService.showToast(data["successMessage"], "Success");
			}
			else {
				this._notificationService.showToast(data["successMessage"], "Warning")
			}
			this.getRoleMenuMappingData();
			this.userMappedObject.clear();
		});
	}

	checkAllMembers(isChecked: boolean, roleId: number) {
		this.menuData.forEach(eachParentMember => {
			this.userMappedObject.set(`${eachParentMember.menuId}_${roleId}`, isChecked);
			this.userMappedObjFromDB.set(`${eachParentMember.menuId}_${roleId}`, isChecked);

			eachParentMember['subMenu'].forEach((eachChildMember: { menuId: any; }) => {
				this.userMappedObject.set(`${eachChildMember.menuId}_${roleId}`, isChecked);
				this.userMappedObjFromDB.set(`${eachChildMember.menuId}_${roleId}`, isChecked);
			});
		});
		this.roleHeader[roleId] = isChecked;
	}

	checkAllRoles(isChecked:boolean,menuId?:any)
	{
		if(!!menuId)
		{
			this.rolesList.forEach((role: { dedId: any; }) => {
				this.userMappedObject.set(`${menuId}_${role.dedId}`,isChecked);
				this.userMappedObjFromDB.set(`${menuId}_${role.dedId}`,isChecked);
			});
		}
		this.menuHeader[menuId] = isChecked;
	}

	formatDataUiToDb() {
		let output: any[] = [];
		let splitData = [];
		this.userMappedObject.forEach((isCheck, key) => {
			splitData = key.split('_');
			output.push(this.convertData(Number(splitData[0]), Number(splitData[1]), isCheck));
		});
		return output;
	}

	isChecked = (menuId: number, roleId: number) => this.userMappedObjFromDB.get(`${menuId}_${roleId}`);

	getRoleMenuMappingData() {
		if(this.businessGroupId)
		this.menuService.getMenuRoleData(this.businessGroupId).subscribe((data: any[]) => {
			this.formatDataDbToUi(data);
		});
	}

	formatDataDbToUi(menuRoles: any[]) {
		menuRoles.forEach(data => {
			this.userMappedObjFromDB.set(`${data.menuId}_${data.roleId}`, data.isActive);
		})
		this.setMenuHeader(null);
		this.setRoleHeader(null);
	}

	setRoleHeader(roleId?: number|null, data?: any[]) {
		if (!roleId) {
			if (this.menuData.length) {
				this.rolesList.forEach((role: { dedId: string | number; roleId: string; }) => {
					this.roleHeader[role.dedId] = this.menuData.every((member) => !!this.userMappedObjFromDB.get(member.menuId + '_' + role.roleId));
				});
			}
		} else {
			this.roleHeader[roleId] = this.menuData.every((member) => !!this.userMappedObject.get(member.menuId + '_' + roleId));
		}
	}

	setMenuHeader(menuId?: number | null, data?: any[])
	{
		if(!menuId)
		{
			if(this.rolesList.length)
			{
				this.menuData.forEach(menu => {
					this.menuHeader[menu.menuId] = this.rolesList.every((role: { dedId: string; }) => !!this.userMappedObjFromDB.get(menu.menuId+'_'+role.dedId));
					menu.subMenu.forEach((subMenu: { menuId: string; }) => {
						this.menuHeader[subMenu.menuId] = this.rolesList.every((role: { dedId: string; }) => !!this.userMappedObjFromDB.get(subMenu.menuId+'_'+role.dedId));						
					});
				});
			}
		}
		else{
			this.menuHeader[menuId]=this.rolesList.every((role: { dedId: string; }) => !!this.userMappedObject.get(menuId+'_'+role.dedId));
		}
	}

	getMenuData() {
		this.menuService.getApplicationMenulist().subscribe(data => {
			this.menuData = [];
			data.forEach((value: { parentMenuId: any; isActive: any; displayName?: string; icon?: string; isAdminMenu?: boolean; isProjectCodeRequired?: boolean; menuId?: number | null; menuOrder?: number | null; routeUrl?: string; help_url?: string | undefined; subMenu?: subMenuModel[] | null; }) => {
				if (value.parentMenuId == null && value.isActive == true) {
					let _menu: any| menuModel = value;
					_menu.subMenu = data.filter((x: { parentMenuId: number | null; isActive: boolean; }) => x.parentMenuId == _menu.menuId && x.isActive == true);
					this.menuData.push(_menu);
				}
			});
		})
	}


	changeBusinessGroup(event:any) {
		if (event.value !== '-2') {
			this.businessGroupId = event.value;
			this.callAPIs();
		}
		else {
			this.menuData = [];
			this.businessGroupId = null;
			this.rolesList = [];
		}
	}

	/**
	* Full screen
	*/
	toggleFullscreen() {
		this.enableFullscreen = !this.enableFullscreen;
	}
	
}
